import React, { FC, useEffect, useState } from "react";

import { Field } from "@progress/kendo-react-form";
import {
	FormInput,
	FormDropDownList,
	FormRadioGroup,
	FormDateTimePicker,
	FormDropDownListWithSearch,
} from "ui/Topography";

import {
	getBuyersFilterApi,
	getQuaySaleBuyersApi,
	getFishingGearApi,
	getCatchAreaApi,
	getQuaySalePortApi,
	getTerminalsApi,
} from "api/common";
import {
	getRegistrationVessels,
	getVesselByIdApi,
	getVesselDetailApi,
} from "api/vessel";

import { Buyer } from "interface/buyer";
import { Vessel } from "interface/vessel";
import { IRegistrationForm } from "interface/registration";
import { useNavigate, useParams } from "react-router";
import { CatchArea, DropDownItem, FishingGear } from "interface/common";

import { createNewRegistrationApi } from "api/registration";
import { Input } from "@progress/kendo-react-inputs";
import { format } from "date-fns";
import { addDays } from "date-fns/addDays";
import { DATE_TIME_FORMAT, ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import { useInfoStore } from "store/error";
import VesselRenderItem from "ui/dropdownItemList/VesselRenderItem";
import { DropdownRenderItem } from "ui/dropdownItemList";
import { useUserStore } from "store/user";

const FormStepOne: FC<{
	form: IRegistrationForm;
	setForm: (reg: IRegistrationForm) => void;
	showRequirement: boolean;
	setMeetRequirement: (meetRequirement: boolean) => void;
	setStep: React.Dispatch<React.SetStateAction<number>>;
	setFormSaved: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({
	form,
	setForm,
	showRequirement,
	setMeetRequirement,
	setStep,
	setFormSaved,
}) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	// const { id: registrationId } = useParams();
	const { setError } = useInfoStore();
	const [vesselDropdown, setVesselDropdown] = useState<Vessel[]>([]);

	const [showVesselError, setShowVesselError] = useState(false);

	const [requirement, setRequirement] = useState({
		vessel: false,
		// receiver: false,
		quaySaleLocation: false,
		receiverType: false,
		terminal: false,
		buyer: false,
		// isTransportNote: false,
		// buyer: false,

		// transportDispensation: false,
		// signingDispensation: false,
	});
	const [ports, setPorts] = useState<DropDownItem[]>([]);
	const [selectedVessel, setSelectedVessel] = useState<Vessel>();
	const { isAdmin } = useUserStore();
	const [quaySaleBuyers, setQuaySaleBuyers] = useState<Buyer[]>([]);

	useEffect(() => {
		if (form?.vesselId) {
			getVessel();
		}
	}, []);

	useEffect(() => {
		handleCheckRequirement();
		// setFormSaved(false);
	}, [form]);

	useEffect(() => {
		if (!isAdmin!) {
			getVesselDropdown();
		}
	}, [isAdmin]);

	const handleCreateRegistration = (form: IRegistrationForm) => {
		if (!form.vesselId) {
			setShowVesselError(true);
			return;
		}
		createNewRegistrationApi(form as any)
			.then((response) => {
				//console.log('createNewRegistrationApi', form, response.data);
				setForm({ ...form, ...response.data });
				setFormSaved(true);
				if (form?.id) {
					return;
				}
				navigate("./" + response.data.id, {
					state: {
						id: response.data.id,
					},
				});
			})
			.catch((err) => {
				if (err?.response?.data) {
					setError(err?.response?.data.returnText);
				} else {
					setError(err.message);
				}
			});
	};

	const getVessel = () => {
		getVesselDetailApi(
			form.vesselId,
			form.vesselRegistrationNumber,
			form.vesselName,
		)
			.then((response) => {
				console.log('set selected vessel', response);
				setSelectedVessel(response);
			})
			.catch((err) => {
				if (err?.response?.data) {
					setError(err?.response?.data.returnText);
				} else {
					setError(err.message);
				}
			});
	};

	const getVesselDropdown = () => {
		const returnAll = true;
		const text = "";
		getRegistrationVessels(text, returnAll)
			.then((response) => {
				if (!response || response === null) {
					setVesselDropdown([]);
					return;
				}
				setVesselDropdown(response);
				if (response.length === 1) {
					// if (form?.vesselId) {
					// 	return;
					// }
					vesselSelected(response[0]);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	};

	const vesselSelected = (vessel: Vessel) => {
		if (!vessel || !vessel.id) {
			return;
		}
		setSelectedVessel(vessel);

		//console.log('form', form);

		const _form: IRegistrationForm = {
			...form,
			vesselId: vessel.id.toString(),
			vesselName: vessel.nm,
			vesselRegistrationNumber: vessel.rn,
			vesselAccountNo: vessel.res?.toString(),
			vesselSource: vessel.sc,
			quaySaleLocationId: null as any,
			quaySalesLocation: null as any,
			//noteType: null as any,
			isQuaySale: null as any,
			isTransportNote: null as any,
			vesselRadioCallSign: vessel.cs,
			hasSigningDispensation: null as any,
		};

		setShowVesselError(false);

		if (!form?.id) {
			//console.log('vesselSelected 1');
			handleCreateRegistration({ ..._form });

			return;
		}
		//console.log('vesselSelected 2');
		handleCreateRegistration({ ..._form });

	};

	const handleRegistrationType = (type: number) => {
		//console.log('handleRegistrationType');
		handleCreateRegistration({
			...form,
			noteType: type,
			buyerId: null as any,
			buyerName: "",
			terminalId: "",
			terminalName: "",
		});
		setStep(0);
	};

	const handleWrasseOption = (value: number) => {
		//console.log('handleWrasseOption');
		handleCreateRegistration({
			...form,
			isWrasseNote: value,
		});
		setStep(0);
	};

	const handleQuayOption = (value: number) => {
		const data: any = {
			noteType: 0,
		};
		if (value === 0) {
			data.noteType = null;
			data.buyerName = null as any;
			data.buyerId = null as any;
		} else {
			if (form.isTransportNote === 1) {
				data.isTransportNote = 0;
			}
			if (form.hasSigningDispensation === 1) {
				data.hasSigningDispensation = 0;
			}
			data.terminalId = null as any;
			data.terminalName = null as any;
			// return;
		}
		setForm({
			...form,
			...data,
			isQuaySale: value,

			quaySaleLocationId: null as any,
			quaySalesLocation: null as any,
		});
		setFormSaved(false);
	};

	const getPorts = () => {
		if (ports && ports.length > 0) return;

		getQuaySalePortApi({ vesselId: form.vesselId as any })
			.then((data) => {
				setPorts([...data, ...ports]);
			})
			.catch((err) => {
				if (err?.response?.data) {
					setError(err?.response?.data.returnText);
				} else {
					setError(err.message);
				}
			});
	};

	const getQuaySaleBuyers = () => {
		if (quaySaleBuyers && quaySaleBuyers.length > 0) return;

		getQuaySaleBuyersApi()
			.then((data) => {
				setQuaySaleBuyers([...data, ...quaySaleBuyers]);
			})
			.catch((err) => {
				if (err?.response?.data) {
					setError(err?.response?.data.returnText);
				} else {
					setError(err.message);
				}
			});
	};

	const handleQuaySelect = (quay: DropDownItem) => {
		//console.log('handleQuaySelect');
		handleCreateRegistration({
			...form,
			quaySaleLocationId: quay.code as any,
			quaySalesLocation: quay.name,
		});
	};

	const handleCheckRequirement = () => {
		if (!form) return;
		//console.log('handleCheckRequirement');
		const _requirement = requirement;
		if (!form?.vesselId) {
			_requirement.vessel = false;
		} else {
			_requirement.vessel = true;
		}

		if (
			form?.isTransportNote === 1 ||
			form?.hasSigningDispensation === 1 ||
			form?.noteType === 0 ||
			form?.isWrasseNote
		) {
			if (form?.buyerId) {
				_requirement.buyer = true;
			} else {
				_requirement.buyer = false;
			}
		} else {
			if (form?.noteType === 1) {
				_requirement.buyer = true;
			} else {
				_requirement.buyer = false;
			}
		}

		if (
			form?.isTransportNote === 1 ||
			form?.hasSigningDispensation === 1 ||
			form?.noteType === 1 ||
			form?.isWrasseNote
		) {
			if (form?.terminalId) {
				_requirement.terminal = true;
			} else {
				_requirement.terminal = false;
			}
		} else {
			if (form?.noteType === 0) {
				_requirement.terminal = true;
			} else {
				_requirement.terminal = false;
			}
		}

		if (form?.noteType === 0 || form?.noteType === 1) {
			_requirement.receiverType = true;
		} else {
			_requirement.receiverType = false;
		}

		if (form.isQuaySale === 1 && !form.quaySaleLocationId) {
			_requirement.quaySaleLocation = false;
		} else {
			_requirement.quaySaleLocation = true;
		}

		setMeetRequirement(
			_requirement.quaySaleLocation &&
				_requirement.buyer &&
				_requirement.vessel &&
				_requirement.terminal &&
				_requirement.receiverType,
		);
		setRequirement({
			..._requirement,
		});
	};

	const disableReceiver = () => {
		if (
			form?.isQuaySale === 1 ||
			form?.isTransportNote === 1 ||
			form?.hasSigningDispensation === 1 ||
			form?.isWrasseNote
		) {
			return true;
		}

		return false;
	};

	const showQuaySale = () => {
		if (selectedVessel?.ta && form.isTransportNote === 1) {
			return false;
		}

		if (
			selectedVessel?.signingDispensation &&
			form.hasSigningDispensation === 1
		) {
			return false;
		}

		return selectedVessel?.qsId;
	};

	const showBuyerInput =
		form?.noteType === 0 ||
		form?.isTransportNote === 1 ||
		form?.hasSigningDispensation === 1 ||
		form?.isWrasseNote;
	// console.log("requirement", requirement);
	return (
		<>
			<Field
				id={"fartøy"}
				name={"fartøy"}
				label={t("Vessel") + "*"}
				data={vesselDropdown}
				textField={"dn"}
				dataItemKey={"id"}
				defaultItem={{
					dn: t("ChooseVessel"),
					id: null,
				}}
				currentValue={{
					id: form?.vesselId ? parseInt(form.vesselId) : null,
					dn: form?.vesselId
						? form?.vesselRegistrationNumber + " | " + form?.vesselName
						: t("ChooseVessel"),
				}}
				filterable={isAdmin}
				filterApi={getRegistrationVessels}
				itemRender={VesselRenderItem}
				component={isAdmin ? FormDropDownListWithSearch : FormDropDownList}
				onChange={(e) => vesselSelected(e.value)}
				showErrorMessage={
					(showRequirement && !requirement.vessel) || showVesselError
				}
			/>
			{form?.id && (
				<>

					{form?.isInWrasseRole && (
						<Field
							id={"Wrasse"}
							name={"Wrasse "}
							label={t("Wrasse") + "*"}
							value={form.isWrasseNote}
							selected={form.isWrasseNote}
							layout={"horizontal"}
							component={FormRadioGroup}
							onChange={(e) => {
								handleWrasseOption(e.value);
							}}
							data={[
								{ label: t("Yes"), value: 1 },
								{ label: t("No"), value: 0 },
							]}
						/>
					)}


					{showQuaySale() && (
						<Field
							id={"Kaisalg"}
							name={"Kaisalg "}
							label={t("QuaySale") + "*"}
							value={form.isQuaySale}
							selected={form.isQuaySale}
							layout={"horizontal"}
							component={FormRadioGroup}
							onChange={(e) => {
								handleQuayOption(e.value);
							}}
							data={[
								{ label: t("Yes"), value: 1 },
								{ label: t("No"), value: 0 },
							]}
						/>
					)}

					{form?.isQuaySale === 1 && (
						<Field
							id={"Kaisalg_sted"}
							name={"Kaisalgssted"}
							label={t("QuaySaleLocation")}
							data={ports}
							textField={"displayName"}
							dataItemKey={"code"}
							currentValue={{
								displayName: form?.quaySalesLocation
									? form.quaySalesLocation
									: t("ChoseQuaySaleLocation"),
								code: form?.quaySaleLocationId ? form.quaySaleLocationId : null,
							}}
							defaultItem={{
								displayName: t("ChoseQuaySaleLocation"),
								code: null,
							}}
							loadDataOnClicked={getPorts}
							onChange={(e) => handleQuaySelect(e.value)}
							component={FormDropDownList}
							showErrorMessage={
								showRequirement && !requirement.quaySaleLocation
							}
						/>
					)}
					{form?.isQuaySale !== 1 && selectedVessel?.ta && (
						<Field
							textField={"label"}
							id={"transportation"}
							name={"transportation "}
							label={t("TransportNote") + "*"}
							selected={form.isTransportNote}
							// selected={form?.hasTransportDispensation}
							layout={"horizontal"}
							component={FormRadioGroup}
							onChange={(e) => {
								let data: any = {
									// terminalId: null,
									isTransportNote: e.value,
									// noteType: null,
									// terminalId: null,
									// terminalName: null,
								};

								if (e.value === 1) {
									data = {
										terminalId: "M UNT",
										terminalName: "M UNT",
										isTransportNote: e.value,
										noteType: 1,
										// hasSigningDispensation: e.value,
									};
								} else {
									if (
										form?.hasSigningDispensation !== 1
										// !selectedVessel.signingDispensation
									) {
										data = {
											...data,
											noteType: null,
											terminalId: null,
											terminalName: null,
											buyerId: null,
											buyerName: null,
										};
									}
								}
								handleCreateRegistration({
									...form,
									...data,
								});
							}}
							data={[
								{ label: t("Yes"), value: 1 },
								{ label: t("No"), value: 0 },
							]}
						/>
					)}
					{form?.isQuaySale !== 1 && selectedVessel?.signingDispensation && (
						<Field
							id={"SigningDispensation"}
							name={"SigningDispensation"}
							label={t("SigningDispensation") + "*"}
							textField={"label"}
							selected={form?.hasSigningDispensation}
							layout={"horizontal"}
							component={FormRadioGroup}
							onChange={(e) => {
								let data: any = {
									// terminalId: null,
									hasSigningDispensation: e.value,
									quaySaleLocationId: null as any,
									quaySalesLocation: null as any,
								};
								if (e.value === 1) {
									data = {
										...data,
										terminalId: "M UNT",
										terminalName: "",
										hasSigningDispensation: e.value,
										noteType: 1,
										// quaySaleLocationId: null as any,
										// quaySalesLocation: null as any,
									};
								} else {
									if (form?.isTransportNote !== 1) {
										data = {
											...data,
											noteType: null,
											terminalId: null,
											terminalName: null,
										};
									}
								}
								handleCreateRegistration({
									...form,
									...data,
								});
							}}
							data={[
								{ label: t("Yes"), value: 1 },
								{ label: t("No"), value: 0 },
							]}
							// showErrorMessage={
							// 	showRequirement && !requirement.signingDispensation
							// }
						/>
					)}
					<Field
						id={"Mottaker"}
						name={"Mottaker"}
						label={t("Receiver") + "*"}
						textField={"label"}
						selected={form?.noteType}
						// loadVesselOnClicked
						layout={"horizontal"}
						component={FormRadioGroup}
						// disabled={selectedVessel?.signingDispensation || selectedVessel?.ta}
						disabled={disableReceiver()}
						onChange={(e) => handleRegistrationType(e.value)}
						data={[
							{ label: t("Buyer"), value: 0 },
							{ label: t("Terminal"), value: 1 },
						]}
						showErrorAMessage={showRequirement && !requirement.receiverType}
					/>

					{form?.noteType === 1 && (
						<Field
							id={"Leveringssted-ID"}
							name={"Leveringssted-ID"}
							label={t("Terminal") + "*"}
							textField={"name"}
							dataItemKey={"code"}
							// data={
							// 	//selectedVessel?.ta || selectedVessel?.signingDispensation
							// 	form?.isTransportNote === 1
							// 		? [
							// 				{
							// 					name: "M UNT",
							// 					displayName: "M UNT",
							// 					code: "M UNT",
							// 				},
							// 		  ]
							// 		: []
							// }
							filterable={
								// selectedVessel?.ta || selectedVessel?.signingDispensation
								// 	? false
								// 	: true
								form?.isTransportNote === 1 ? false : true
							}
							// onChange={(value: DropDownListChangeEvent) => console.log(value)}
							filterApi={getTerminalsApi}
							defaultItem={{
								name: t("ChooseTerminal"),
								code: null,
							}}
							defaultValue={{
								name: t("ChooseTerminal"),
								code: null,
							}}
							currentValue={{
								code: form?.terminalId ? form.terminalId : null,
								name: form?.terminalName
									? form.terminalName
									: form?.terminalId === "M UNT"
										? "M UNT"
										: t("ChooseTerminal"),
							}}
							onSelect={(terminal: DropDownItem) => {
								let data = {
									terminalId: terminal.code as any,
									terminalName: terminal.name,
									buyerName: form?.buyerName,
									buyerId: form?.buyerId,
								};
								if (
									form?.isTransportNote !== 1 &&
									form?.hasSigningDispensation !== 1
								) {
									data = {
										...data,
										buyerName: null as any,
										buyerId: null as any,
									};
								}
								handleCreateRegistration({
									...form,
									...data,
								});
							}}
							itemRender={DropdownRenderItem}
							component={FormDropDownListWithSearch}
							showErrorMessage={showRequirement && !requirement.terminal}
							disabled={disableReceiver()}
						/>
					)}

					{showBuyerInput && form?.isQuaySale === 1 && (
						<Field
							id={"Kjøper"}
							name={"Kjøper"}
							label={t("Buyer") + "*"}
							data={quaySaleBuyers}
							textField={"name"}
							dataItemKey={"id"}
							currentValue={{
								id: form?.buyerId ? form.buyerId : null,
								name: form?.buyerName ? form.buyerName : t("ChooseBuyer"),
							}}
							defaultItem={{
								name: t("ChooseBuyer"),
								id: null,
							}}
							loadDataOnClicked={getQuaySaleBuyers}
							onSelect={(buyer: Buyer) => {
								let data = {};
								if (
									form?.isTransportNote !== 1 &&
									form?.hasSigningDispensation !== 1
								) {
									data = {
										terminalId: null,
										terminalName: null,
									};
								}
								handleCreateRegistration({
									...form,
									...data,
									buyerId: buyer.id,
									buyerName: buyer.name,
								});
							}}
							component={FormDropDownList}
							filterable={false}
							showErrorMessage={showRequirement && !requirement.buyer}
						/>
					)}

					{showBuyerInput && form?.isQuaySale !== 1 && (
						<Field
							id={"Kjøper"}
							name={"Kjøper"}
							label={t("Buyer") + "*"}
							textField={"name"}
							dataItemKey={"id"}
							defaultItem={{
								name: t("ChooseBuyer"),
								id: null,
							}}
							filterable={true}
							currentValue={{
								id: form?.buyerId ? form.buyerId : null,
								name: form?.buyerName ? form.buyerName : t("ChooseBuyer"),
							}}
							filterApi={getBuyersFilterApi}
							onSelect={(buyer: Buyer) => {
								let data = {};
								if (
									form?.isTransportNote !== 1 &&
									form?.hasSigningDispensation !== 1
								) {
									data = {
										terminalId: null,
										terminalName: null,
									};
								}
								handleCreateRegistration({
									...form,
									...data,
									buyerId: buyer.id,
									buyerName: buyer.name,
								});
							}}
							component={FormDropDownListWithSearch}
							showErrorMessage={showRequirement && !requirement.buyer}
						/>
					)}

					<Field
						id={"DeliveryDate"}
						name={"Leveringsdato og tidspunkt"}
						label={t("DeliveryDateAndTime")}
						placeholder=""
						currentValue={form.deliveryDate}
						min={addDays(new Date(), -1)}
						dateInput={() => <CustomDateInput form={form} setForm={setForm} />}
						onChange={(e) => {
							handleCreateRegistration({
								...form,
								deliveryDate: e.value,
							});
						}}
						component={FormDateTimePicker}
					/>
					<Field
						id={"Redskap"}
						name={"Redskap"}
						label={t("FishingGear")}
						value={t("ChooseFishingGear")}
						filterable={true}
						textField={"displayName"}
						dataItemKey={"id"}
						filterApi={getFishingGearApi}
						defaultItem={{
							displayName: t("ChooseFishingGear"),
							id: null,
						}}
						currentValue={{
							id: form?.fishingGearId ? form.fishingGearId : null,
							displayName: form?.fishingGear,
						}}
						// className="error"
						onSelect={(fishingGear: FishingGear) =>
							handleCreateRegistration({
								...form,
								fishingGearId: fishingGear.id as any,
								fishingGear: fishingGear.name,
							})
						}
						component={FormDropDownListWithSearch}
					/>
					<Field
						id={"CatchArea"}
						name={"Fangstfelt og sone"}
						label={t("CatchAreaAndZone")}
						value={t("ChooseCatchAreaAndZone")}
						filterable={true}
						textField={"displayName"}
						dataItemKey={"id"}
						filterApi={getCatchAreaApi}
						defaultItem={{
							displayName: t("ChooseCatchAreaAndZone"),
							id: null,
						}}
						currentValue={{
							id: form?.catchAreaId,
							displayName: form?.fishingArea,
						}}
						// className="error"
						onSelect={(catchArea: CatchArea) =>
							handleCreateRegistration({
								...form,
								catchAreaId: catchArea.id as any,
								fishingArea: catchArea.name,
							})
						}
						component={FormDropDownListWithSearch}
					/>

					<Field
						id={"Information"}
						name={"Lokalitet"}
						label={t("Location")}
						placeholder=""
						defaultValue={form.information}
						currentValue={form.information}
						onChange={(e) => {
							setFormSaved(false);
							setForm({
								...form,
								information: e.value,
							});
						}}
						//should be onblur  but confliting with default method in kendo
						saveItem={(e: any) => {
							handleCreateRegistration({
								...form,
								information: e.target.value,
							});
						}}
						component={FormInput}
					/>
				</>
			)}
		</>
	);
};

export default FormStepOne;

const CustomDateInput: FC<{
	form: IRegistrationForm;
	setForm: (form: IRegistrationForm) => void;
}> = ({ form, setForm }) => {
	let value = "";

	if (form?.deliveryDate && form.deliveryDate !== null) {
		value = format(new Date(form.deliveryDate).toString(), DATE_TIME_FORMAT);
	}

	return (
		<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
			<Input style={{ border: "none" }} value={value} />
			{value && (
				<button
					type="button"
					onClick={() => setForm({ ...form, deliveryDate: null as any })}
					style={{
						marginLeft: "10px",
						padding: "5px 10px",
						color: "white",
						border: "none",
						cursor: "pointer",
						marginRight: "5px",
					}}
				>
					<img
						src={`/icon/cancel.svg`}
						alt="cancel"
						style={{
							width: `14px`,
							height: `14px`,
							backgroundColor: "transparent",
						}}
					/>
				</button>
			)}
		</div>
	);
};
